import { render } from "./instructor-quiz.vue?vue&type=template&id=8d2fedf0"
import script from "./instructor-quiz.vue?vue&type=script&lang=js"
export * from "./instructor-quiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__